var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "physical_card_tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "实体卡", name: "physical_card_table" } },
            [
              _c("physical-card-list-pane", {
                ref: "physical_card_table",
                attrs: { "img-access-domain": _vm.imgAccessDomain },
                on: { toCardList: _vm.handleToCardList },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "实体卡列表", name: "physical_card_detail" } },
            [
              _vm.activeName === "physical_card_detail"
                ? _c("physical-card-detail-pane", {
                    attrs: {
                      "cr-id": _vm.currentCrId,
                      "card-type-name": _vm.currentCardTypeName,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }